import React from 'react';

const Footer = () => {
  return (
    <div>
        <div className='text-center p-6 bg-gray-800 text-white text-sm font-light font-mono'>
            <p>Design & Developed By Shubhanshu Rao✌️✌️</p>
        </div>
    </div>
  )
}

export default Footer;